import React, {useContext} from 'react';

import {styled} from "@mui/material/styles";

import {BadgeContext} from "../BadgeContext";

const StyledIndicator = styled('div', {shouldForwardProp: (prop) => 'color' !== prop})(({ theme, color }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '2px',
    backgroundColor: theme.palette[color]?.main ?? color,
}));

const RoundIndicator = styled('div', {shouldForwardProp: (prop) => 'color' !== prop})(({ theme, color }) => ({
    width: '6px',
    height: '6px',
    borderRadius: '999px',
    backgroundColor: theme.palette[color]?.main ?? color,
}));

function Indicator(props) {
    const {color, indicatorColor, indicator} = useContext(BadgeContext);

    if (indicator === true || indicator === 'square') {
        return <StyledIndicator color={indicatorColor ?? color} />
    }

    if (indicator === 'circle') {
        return <RoundIndicator color={indicatorColor ?? color} />
    }

    return null;
}

export default Indicator;
